import axios from 'axios';
import { BACKEND_URL, HEADERS, STORAGE_KEYS } from 'const';
import AuthService from './AuthService';
import { nanoid } from 'nanoid';

const sessionid = nanoid();
localStorage.setItem(STORAGE_KEYS.SESSION_ID, sessionid);

async function getData(path, headers = {}, params = {}, responseType) {
  const resp = await _request(path, {
    method: 'GET',
    ..._genParams(headers, params, responseType),
  });
  return _getResponseData(resp);
}

async function postData(path, data, headers, params, responseType) {
  const resp = await _request(path, {
    method: 'POST',
    data,
    ..._genParams(headers, params, responseType),
  });
  return _getResponseData(resp);
}


async function get(path, headers, params, responseType) {
  const resp = await _request(path, {
    method: 'GET',
    ..._genParams(headers, params, responseType),
  });

  return _getResponse(resp);
}

async function post(path, data, headers, params, responseType) {
  const resp = await _request(path, {
    method: 'POST',
    data,
    ..._genParams(headers, params, responseType),
  });

  return _getResponse(resp);
}

async function destroy(path, data, headers, params, responseType) {
  const resp = await _request(path, {
    method: 'DELETE',
    data,
    ..._genParams(headers, params, responseType),
  });
  return _getResponseData(resp);
}

async function put(path, data) {
  const resp = await _request(path, {
    method: 'PUT',
    data,
    ..._genParams(),
  });
  return _getResponseData(resp);
}

async function patch(path, data) {
  const resp = await _request(path, { method: 'PATCH', data, ..._genParams() });
  return _getResponseData(resp);
}

async function _request(path, config) {
  try {
    return await axios({ url: `${BACKEND_URL}${path}`, ...config });
  } catch (error) {
    if (_isInvalidTokenError(error)) {
      await _handleInvalidTokenError();
    } else {
      throw error;
    }
  }
}

function _genParams(headers = {}, params = {}, responseType = undefined) {
  const authToken = localStorage.getItem(STORAGE_KEYS.TOKEN);

  const localHeaders = {
    ...headers,
    [HEADERS.AUTH]: authToken ? `Token ${authToken}` : headers[HEADERS.AUTH],
    [HEADERS.SESSION_ID]: sessionid,
  };

  if (!headers[HEADERS.SHOP_ID]) {
    const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
    if (shopId) {
      localHeaders[HEADERS.SHOP_ID] = shopId;
    }
  }

  return {
    headers: localHeaders,
    params,
    responseType,
  };
}

async function _getResponseData(resp) {
  if (resp?.data?.status !== undefined) {
    if (resp.data.status === 200) {
      return resp.data.data;
    }
    const errorMessage = resp?.data?.message || resp?.data?.error || 'Request failed';
    const err = new Error(errorMessage);
    if (resp?.data?.status_code) {
      err.status_code = resp.data.status_code;
    }
    throw err;
  }
  if (resp?.status === 200) {
    return resp.data;
  }
  const errorMessage = resp?.data?.message || resp?.data?.error || 'Request failed';
  const err = new Error(errorMessage);
  if (resp?.status_code) {
    err.status_code = resp.status_code;
  }
  throw err;
}

async function _getResponse(resp) {
  if (resp?.data?.status === 200) {
    return resp.data;
  }
  if (resp?.status === 200) {
    return { data: resp.data, status: 200 };
  }
  const errorMessage = (resp.data || {}).message || 'Request failed';
  const err = new Error(errorMessage);
  if (resp?.status_code) {
    err.status_code = resp.status_code;
  }
  throw err;
}

function _isInvalidTokenError(error) {
  return error?.response?.status === 401;
}

async function _handleInvalidTokenError() {
  await AuthService.logout();
  window.location.reload();
}

const BackendService = {
  getData,
  postData,
  get,
  post,
  put,
  patch,
  destroy,
};

export default BackendService;
